<div class="historial" *ngIf="orden">
  <!-- Creación -->
  <div class="paso completado">
    <div class="icono">
      <mat-icon>{{ Icono.CREAR_ORDEN }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Creación</h3>
      <p class="mat-small">
        {{ orden.fechaCreacion | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div class="cont-notas">
      <p>ID Orden: {{ orden.id }}</p>
      <p *ngIf="orden.autorCreacion">Autor: {{ orden.autorCreacion }}</p>
    </div>
  </div>

  <!-- Aplazamiento -->
  <div class="paso completado" *ngIf="orden.aplazadaHasta">
    <div class="icono">
      <mat-icon>{{ Icono.APLAZAR }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Aplazamiento</h3>
      <p class="mat-small">
        {{ orden.fechaAplazamiento | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div class="cont-notas">
      <p>
        Aplazada Hasta:
        {{ orden.aplazadaHasta | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
      <p *ngIf="orden.motivoAplazamiento">
        Motivo: {{ orden.motivoAplazamiento }}
      </p>
      <p *ngIf="orden.autorAplazamiento">
        Autor: {{ orden.autorAplazamiento }}
      </p>
    </div>
  </div>

  <!-- Preparación -->
  <div
    class="paso"
    [class.completado]="ESTADOS_ORDEN_PREPARADA.includes(orden.estado)"
    [class.activo]="orden.estado === EstadoOrden.POR_PREPARAR"
    [class.error]="orden.estado === EstadoOrden.RECHAZADA"
  >
    <div class="icono">
      <mat-icon>{{ Icono.PREPARACION }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Preparación</h3>
      <p class="mat-small" *ngIf="orden.fechaPreparacion; else noFecha">
        {{ orden.fechaPreparacion | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div
      class="cont-notas"
      *ngIf="ESTADOS_ORDEN_PREPARADA.includes(orden.estado)"
    >
      <p>
        Acción:
        {{
          orden.estado === EstadoOrden.RECHAZADA
            ? "Rechazada"
            : orden.tipoPreparacion === TipoPreparacion.PARCIAL
              ? "Preparada Parcialmente"
              : "Preparada"
        }}
      </p>
      <p *ngIf="orden.motivoRechazo">Motivo: {{ orden.motivoRechazo }}</p>
      <p *ngIf="orden.origen">Farmacia: {{ orden.origen.nombre }}</p>
      <p *ngIf="orden.observacionPreparacion">
        Observación: {{ orden.observacionPreparacion }}
      </p>
      <p *ngIf="orden.autorPreparacion">Autor: {{ orden.autorPreparacion }}</p>
    </div>
  </div>

  <!-- Recogida -->
  <div
    class="paso"
    [class.completado]="orden.estado === EstadoOrden.RECOGIDA"
    [class.activo]="
      orden.estado === EstadoOrden.PREPARADA && !orden.sinDomicilio
    "
    [class.error]="orden.sinDomicilio"
  >
    <div class="icono">
      <mat-icon>{{ Icono.RECOGIDA }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Recogida</h3>
      <p class="mat-small" *ngIf="orden.fechaRecogida; else noFecha">
        {{ orden.fechaRecogida | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div class="cont-notas" *ngIf="orden.estado === EstadoOrden.RECOGIDA">
      <p *ngIf="orden.origen">Farmacia: {{ orden.origen.nombre }}</p>
      <p *ngIf="orden.autorRecogida">Autor: {{ orden.autorRecogida }}</p>
    </div>
    <div class="cont-notas" *ngIf="orden.sinDomicilio">
      <p>Acción: Domicilios no solicitado</p>
      <p *ngIf="orden.motivoSinDomicilio">
        Motivo: {{ orden.motivoSinDomicilio }}
      </p>
      <p *ngIf="orden.origen">Farmacia: {{ orden.origen.nombre }}</p>
      <p *ngIf="orden.autorPreparacion">Autor: {{ orden.autorPreparacion }}</p>
    </div>
  </div>

  <!-- Domicilios -->
  <ng-container
    *ngFor="let domicilio of domicilios"
    [ngTemplateOutlet]="domicilioRef"
    [ngTemplateOutletContext]="{ $implicit: domicilio }"
  ></ng-container>
</div>

<ng-template #domicilioRef let-domicilio>
  <!-- Enrutamiento -->
  <div
    class="paso"
    [class.completado]="
      domicilio && ESTADOS_DOMICILIO_RUTA.includes(domicilio.estado)
    "
    [class.activo]="domicilio && domicilio.estado === EstadoDomicilio.BODEGA"
    [class.error]="domicilio && domicilio.estado === EstadoDomicilio.CANCELADO"
  >
    <div class="icono">
      <mat-icon>{{ Icono.ENRUTAMIENTO }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Enrutamiento</h3>
      <p class="mat-small" *ngIf="domicilio?.fechaEnrutamiento; else noFecha">
        {{
          domicilio.fechaEnrutamiento | date: FORMATO_FECHA_PIPE_2 | titlecase
        }}
      </p>
    </div>
    <div
      class="cont-notas"
      *ngIf="domicilio && ESTADOS_DOMICILIO_RUTA.includes(domicilio.estado)"
    >
      <p>ID Domicilio: {{ domicilio.id }}</p>
      <p *ngIf="domicilio.ruta?.vehiculo">
        Vehículo: {{ domicilio.ruta?.vehiculo?.nombre }}
      </p>
      <p *ngIf="domicilio.aliado">Aliado: {{ domicilio.aliado }}</p>
    </div>
    <div
      class="cont-notas"
      *ngIf="domicilio?.estado === EstadoDomicilio.CANCELADO"
    >
      <p>Acción: Cancelado</p>
      <p *ngIf="domicilio.motivoCancelacion">
        Motivo: {{ domicilio.motivoCancelacion }}
      </p>
      <p *ngIf="domicilio.observacionCancelacion">
        Observación: {{ domicilio.observacionCancelacion }}
      </p>
      <p *ngIf="domicilio.autorCancelacion">
        Autor: {{ domicilio.autorCancelacion }}
      </p>
    </div>
  </div>

  <!-- Despacho -->
  <div
    class="paso"
    [class.completado]="
      domicilio && ESTADOS_DOMICILIO_DESPACHADO.includes(domicilio.estado)
    "
    [class.activo]="domicilio?.estado === EstadoDomicilio.RUTA"
  >
    <div class="icono">
      <mat-icon>{{ Icono.DESPACHO }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Despacho</h3>
      <p class="mat-small" *ngIf="domicilio?.fechaDespacho; else noFecha">
        {{ domicilio.fechaDespacho | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div
      class="cont-notas"
      *ngIf="
        domicilio &&
        ESTADOS_DOMICILIO_DESPACHADO.includes(domicilio.estado) &&
        domicilio.autorDespacho
      "
    >
      <p *ngIf="domicilio.autorDespacho">
        Autor: {{ domicilio.autorDespacho }}
      </p>
    </div>
  </div>

  <!-- Checkout -->
  <div
    class="paso"
    [class.completado]="domicilio?.estado === EstadoDomicilio.ENTREGADO"
    [class.activo]="domicilio?.estado === EstadoDomicilio.DESPACHADO"
    [class.error]="
      domicilio && ESTADOS_DOMICILIO_FALLIDO.includes(domicilio.estado)
    "
  >
    <div class="icono">
      <mat-icon>{{ Icono.ENTREGA }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Entrega</h3>
      <p class="mat-small" *ngIf="domicilio?.fechaCheckout; else noFecha">
        {{ domicilio.fechaCheckout | date: FORMATO_FECHA_PIPE_2 | titlecase }}
      </p>
    </div>
    <div
      class="cont-notas"
      *ngIf="
        domicilio && ESTADOS_DOMICILIO_COMPLETADO.includes(domicilio.estado)
      "
    >
      <p>
        Acción:
        {{
          domicilio.estado === EstadoDomicilio.ENTREGADO
            ? "Entregado"
            : "Fallido"
        }}
      </p>
      <p *ngIf="domicilio.observacionCheckout">
        Observación: {{ domicilio.observacionCheckout }}
      </p>
      <p *ngIf="domicilio.comentariosCheckout">
        Comentarios: {{ domicilio.comentariosCheckout }}
      </p>
      <ng-container
        *ngIf="domicilio.fotosCheckout && domicilio.fotosCheckout.length > 0"
      >
        <p>Fotos:</p>
        <div class="fotos">
          <a
            *ngFor="let foto of domicilio.fotosCheckout"
            [href]="foto"
            target="_blank"
          >
            <img [src]="foto" class="foto" alt="Foto de entrega" />
          </a>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Legalización -->
  <div
    class="paso"
    [class.completado]="domicilio?.legalizado"
    [class.activo]="
      domicilio &&
      !domicilio.legalizado &&
      ESTADOS_DOMICILIO_COMPLETADO.includes(domicilio.estado)
    "
  >
    <div class="icono">
      <mat-icon>{{ Icono.LEGALIZACION }}</mat-icon>
    </div>
    <div class="cont-titulo">
      <h3>Legalización</h3>
      <p class="mat-small" *ngIf="domicilio?.fechaLegalizacion; else noFecha">
        {{
          domicilio.fechaLegalizacion | date: FORMATO_FECHA_PIPE_2 | titlecase
        }}
      </p>
    </div>
    <div class="cont-notas" *ngIf="domicilio?.legalizado">
      <p>
        Acción:
        {{
          domicilio.estado === EstadoDomicilio.REPROGRAMADO
            ? "Re-programado"
            : "Devuelto a Farmacia"
        }}
      </p>
      <p *ngIf="domicilio.observacionLegalizacion">
        Observación: {{ domicilio.observacionLegalizacion }}
      </p>
    </div>
  </div>
</ng-template>

<!-- Template para mostrar "N/A" cuando no hay fecha -->
<ng-template #noFecha>
  <p class="mat-small">N/A</p>
</ng-template>

<div class="cargando" *ngIf="cargando()">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div class="sin-datos" *ngIf="!cargando() && orden === undefined">
  <mat-icon>info</mat-icon>
  <span>No se encontraron datos de la orden.</span>
</div>
